import React from 'react';
import { Form, Input, Select, Checkbox } from 'semantic-ui-react';
import { PageSection } from 'common/styles/page';
import { TimeZones } from 'common/constants/TimeZones';

interface OrganizationPropertiesFormProps {
  formValue: {
    name: string;
    time_zone: string;
    tier?: number;
    team_leader_dashboard: boolean;
    nulogic_benchmarks: boolean;
    pulse_surveys: boolean;
    team_leader_dashboard_audience: 'all_leaders' | 'organization_admin_only';
  };
  formErrors: { name?: string };
  onChange: (
    field:
      | 'name'
      | 'time_zone'
      | 'tier'
      | 'team_leader_dashboard'
      | 'nulogic_benchmarks'
      | 'pulse_surveys'
      | 'team_leader_dashboard_audience',
    value: string | number | boolean
  ) => void;
}

const TIER_OPTIONS = [
  { key: 1, value: 1, text: 'Tier 1 - Insight' },
  { key: 2, value: 2, text: 'Tier 2 - Improve' },
  { key: 3, value: 3, text: 'Tier 3 - Lead' },
  { key: 4, value: 4, text: 'Tier 4 - Enterprise' },
];

const OrganizationPropertiesForm: React.FC<OrganizationPropertiesFormProps> = ({
    formValue,
    formErrors,
    onChange,
}) => (
        <PageSection>
            <Form>
                <Form.Group widths="equal">
                    <Form.Field required style={{ display: 'flex', alignItems: 'center' }}>
                        <label style={{ minWidth: 180, marginRight: '1rem' }}>Organization Name</label>
                        <Input
                            placeholder="Enter organization name"
                            value={formValue.name}
                            onChange={(_, { value }) => onChange('name', value)}
                            style={{ width: 400 }}
                        />
                    </Form.Field>
                </Form.Group>

                <Form.Group widths="equal">
                    <Form.Field required style={{ display: 'flex', alignItems: 'center' }}>
                        <label style={{ minWidth: 180, marginRight: '1rem' }}>Time Zone</label>
                        <Select
                            placeholder="Select time zone"
                            options={TimeZones.map(tz => ({ key: tz.value, value: tz.value, text: tz.text }))}
                            value={formValue.time_zone}
                            onChange={(_, { value }) => onChange('time_zone', value as string)}
                            style={{ width: 400 }}
                        />
                    </Form.Field>
                </Form.Group>

                <Form.Group widths="equal">
                    <Form.Field style={{ display: 'flex', alignItems: 'center' }}>
                        <label style={{ minWidth: 180, marginRight: '1rem' }}>Tier</label>
                        <Select
                            placeholder="Select tier"
                            options={TIER_OPTIONS}
                            value={formValue.tier}
                            onChange={(_, { value }) => onChange('tier', value as number)}
                            style={{ width: 400 }}
                        />
                    </Form.Field>
                </Form.Group>

                <Form.Group widths="equal">
                    <Form.Field style={{ display: 'flex', alignItems: 'center' }}>
                        <label style={{ minWidth: 180, marginRight: '1rem' }}>Team Leader Dashboard</label>
                        <Checkbox
                            toggle
                            label={formValue.team_leader_dashboard ? 'Enabled' : 'Disabled'}
                            checked={formValue.team_leader_dashboard}
                            onChange={(_, { checked }) => onChange('team_leader_dashboard', checked as boolean)}
                        />
                    </Form.Field>
                </Form.Group>

                  <Form.Group widths="equal">
                    <Form.Field style={{ display: 'flex', alignItems: 'center' }}>
                      <label style={{ minWidth: 180, marginRight: '1rem' }}>nuLogic Benchmarks</label>
                      <Checkbox
                        toggle
                        label={formValue.nulogic_benchmarks ? 'Enabled' : 'Disabled'}
                        checked={formValue.nulogic_benchmarks}
                        onChange={(_, { checked }) => onChange('nulogic_benchmarks', checked as boolean)}
                      />
                    </Form.Field>
                  </Form.Group>

                  <Form.Group widths="equal">
                    <Form.Field style={{ display: 'flex', alignItems: 'center' }}>
                      <label style={{ minWidth: 180, marginRight: '1rem' }}>Pulse Surveys</label>
                      <Checkbox
                        toggle
                        label={formValue.pulse_surveys ? 'Enabled' : 'Disabled'}
                        checked={formValue.pulse_surveys}
                        onChange={(_, { checked }) => onChange('pulse_surveys', checked as boolean)}
                      />
                    </Form.Field>
                  </Form.Group>

                {formValue.team_leader_dashboard && (
                  <Form.Group widths="equal">
                    <Form.Field style={{ display: 'flex', alignItems: 'center' }}>
                      <label style={{ minWidth: 180, marginRight: '1rem' }}>Leaderboard Audience</label>
                      <Select
                        placeholder="Select audience"
                        options={[
                          { key: 'all_leaders', value: 'all_leaders', text: 'All leaders' },
                          { key: 'organization_admin_only', value: 'organization_admin_only', text: 'Org Admin only' },
                        ]}
                        value={formValue.team_leader_dashboard_audience}
                        onChange={(_, { value }) => onChange('team_leader_dashboard_audience', value as string)}
                        style={{ width: 400 }}
                      />
                    </Form.Field>
                  </Form.Group>
                )}
            </Form>

        </PageSection>
    );

export default OrganizationPropertiesForm;
